import React from 'react';
import {Typography, Tooltip, TypographyProps} from '@mui/material';
export interface AppEllipsisTypographyProps extends Omit<TypographyProps, 'children'> {
    maxLetters?: number;
    text: string;
    hideDetails?: boolean;
    whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line';
}
export const AppEllipsisTypography: React.FC<AppEllipsisTypographyProps> = ({
    text,
    hideDetails = false,
    whiteSpace = 'nowrap',
    maxLetters = 20,
    ...rest
}) => {
    // Check if text needs to be truncated
    const shouldTruncate = text.length > maxLetters;

    // Truncate text if necessary
    const displayedText = shouldTruncate ? `${text.substring(0, maxLetters)}...` : text;

    return (
        <Tooltip title={text} disableHoverListener={!shouldTruncate || hideDetails} arrow>
            <Typography
                {...rest}
                sx={{
                    display: 'inline-block',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: whiteSpace,
                }}
            >
                {displayedText}
            </Typography>
        </Tooltip>
    );
};
export default AppEllipsisTypography;
